

import dynamic from "next/dynamic";
import { GetAuthURL } from "../../pages/api/API";
import Icon from "../Icon";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";

const SignUpButton = dynamic(() => import("../common/SingUpButton.js"));
const LinkedInLogin = () => {
    const handleLinkedin = async () => {
        let reponse = await GetAuthURL("LinkedIn");

        const width = 600;
        const height = 600;
        const left = window.innerWidth / 2 - width / 2;
        const top = window.innerHeight / 2 - height / 2;
        const url = `${reponse.Data.AuthURL}`;

        return window.open(url, "", `toolbar=no, location=no, directories=no, status=no, menubar=no,
        scrollbars=no, resizable=no, copyhistory=no, width=${width},
        height=${height}, top=${top}, left=${left}`
        );
    }
    return (
        <SignUpButton
            onClick={handleLinkedin}
            level="m"
            left={
                <Icon
                    Icon={faLinkedin}
                    size={20}
                    color="#0e76a8"
                />
            }
        >
            Linkedin
        </SignUpButton>
    )
}

export default LinkedInLogin;